import React from 'react'
import { Grid, Skeleton } from '@mui/material'

// โครง skeleton สำหรับ dashboard ทั้งเจ้าหน้าที่และผู้บริหาร (แสดงตอนโหลดครั้งแรก)
export default function DashboardSkeleton() {
    return (
        <div className="container-fluid" style={{ padding: '10px' }}>
            <Grid container spacing={2}>
                {[1, 2, 3, 4].map((i) => (
                    <Grid item md={3} sm={6} xs={12} key={i}>
                        <Skeleton variant="rounded" height={160} />
                    </Grid>
                ))}
                <Grid item md={6} xs={12}>
                    <Skeleton variant="rounded" height={340} />
                </Grid>
                <Grid item md={6} xs={12}>
                    <Skeleton variant="rounded" height={340} />
                </Grid>
                <Grid item xs={12}>
                    <Skeleton variant="rounded" height={300} />
                </Grid>
            </Grid>
        </div>
    )
}
